import React from "react";
import { motion } from "framer-motion";
import Button from "../../components/Button/Button";

const BeautyHero = () => {
  return (
    <section className="w-full  bg-white pt-8">
      <div className="max-w-7xl mx-auto px-6 flex flex-col-reverse lg:flex-row items-center gap-12">
        
        {/* Left Text Content */}
        <div className="flex-1 text-center lg:text-left">
          <motion.span
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-block  bg-purple-100 text-purple-700  text-xs font-semibold px-3 py-1 rounded-full mb-4"
          >
            Zola For Beauty
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
          >
            Elevate Client Care & Loyalty<br />
            in the <span className="text-purple-600">Beauty Industry</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-gray-600 mt-4"
          >
            Zola helps salons and beauticians capture real-time client feedback,
            automate reviews, and build loyal client relationships with ease.
          </motion.p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
            <Button variant="primary">Get Started</Button>
            <Button variant="secondary" calendly>
              Book a demo
            </Button>
          </div>
        </div>

        {/* Right Image */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex-1"
        >
          <img
            src="https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTN8fHNhbG9ufGVufDB8fDB8fHww"
            alt="Beauty salon experience"
            className="rounded-xl shadow-lg"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default BeautyHero;
